import { DashboardHelper } from './../dashboard.service';
import { Injectable } from '@angular/core';
import { DirectoryService } from '../api/directory.api.service';
import { Observable, BehaviorSubject } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { DirectoryModel } from '../../models/directory.model';
import { List } from 'immutable';
import { BaseDataStore } from './base-data.store';
import { AlertService } from '../alert.service';

@Injectable({
  providedIn: 'root',
})
export class DirectoryStore extends BaseDataStore {
  private _directories: BehaviorSubject<List<DirectoryModel>> = new BehaviorSubject(List<DirectoryModel>([]));
  public $directories: Observable<List<DirectoryModel>> = this._directories.asObservable();

  constructor(
    private directoryService: DirectoryService,
    private dashboardHelper: DashboardHelper,
    private alertService: AlertService,
  ) {
    super();
    this.behaviorSubjectList.push(this._directories);
  }

  public loadInitialData(): void {
    this.directoryService.getDirectories().subscribe({
      next: (res: any) => {
        if (res) {
          const directories = (<Object[]>res).map(
            (directory: any) =>
              new DirectoryModel({
                id: directory.id,
                organizationId: directory.organizationId,
                description: directory.description,
                createdDate: directory.createDate,
                modifiedDate: directory.modifiedDate,
                createdBy: directory.createdBy,
                modifiedBy: directory.modifiedBy,
                isActive: directory.isActive,
                directoryType: directory.directoryType,
                directoryName: directory.directoryName,
                lowerDirectoryName: directory.lowerDirectoryName,
                directoryPosition: directory.directoryPosition,
              }),
          );
          this._directories.next(List(directories));
        }
      },
      error: (err) => {
        // RxJS never fires `complete` after `error` - increment here too, otherwise a failed request
        // leaves dashboardHelper.initCount permanently short and the app-init loading dialog never closes
        // (see ui-state.store.ts's initCount >= 9 gate).
        console.log('Error retrieving Directories');
        this.alertService.showError('Error retrieving Directories!');
        this.dashboardHelper.initCount += 1;
      },
      complete: () => {
        this.dashboardHelper.initCount += 1;
      },
    });
  }

  public $addDirectory(newDirectory: DirectoryModel): Observable<any> {
    // Make web api call to add directory
    // shareReplay(1) ensures the HTTP request only fires once even though both this method's
    // internal subscribe() and the caller's subscribe() (directory-detail.component.ts's save())
    // subscribe to the same observable - without it each subscription re-runs the cold HttpClient
    // request, creating the directory twice.
    const obs = this.directoryService.saveDirectory(newDirectory).pipe(shareReplay(1));

    obs.subscribe((res: any) => {
      this._directories.next(this._directories.getValue().push(new DirectoryModel(res)));
    });

    return obs;
  }

  public $updateDirectory(newDirectory: DirectoryModel): Observable<any> {
    // Make web api call to add directory
    // shareReplay(1): see $addDirectory above - prevents the update request from firing twice.
    const obs = this.directoryService.updateDirectory(newDirectory).pipe(shareReplay(1));

    obs.subscribe((res: any) => {
      // const updatedDir = new DirectoryModel(res);
      // const dirs = this._directories.getValue();
      // const foundDir = dirs.find(d => d.id === updatedDir.id);
      // if (foundDir) {
      //   dirs[dirs.indexOf(foundDir)] = updatedDir;
      // }

      // this._directories.next(dirs);
      this.loadInitialData();
    });

    return obs;
  }
}
